<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />
      <div class="card">
        <div class="title">
          Laporan Barang Masuk perbulan per kelompok barang
        </div>
        <DataTable
          :value="items"
          :paginator="true"
          class="p-datatable-outlets"
          :rows="limit"
          :rowHover="true"
          :scrollable="true"
          :loading="loading"
          :lazy="true"
          :totalRecords="total_records"
          @page="getReportInbound($event)"
        >
          <template #header>
            <div class="p-grid p-fluid p-mb-2">
              <div class="p-col-3" style="margin-top: 2.2rem">
                <Calendar
                  v-model="start_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="Start Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col-3" style="margin-top: 2.2rem">
                <Calendar
                  v-model="end_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="End Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col-3" style="margin-top: 2.2rem">
                <Button
                  label="Cari"
                  class="p-button-primary"
                  icon="pi pi-search"
                  @click="getReportInboundFilter()"
                  v-shortkey.push="['enter']"
                  @shortkey="getReportInboundFilter()"
                />
              </div>
              <div
                class="p-col-3"
                style="
                  margin-top: 2.2rem;
                  display: flex;
                  justify-content: flex-end;
                "
              >
                <Button
                  label="Export Excel"
                  class="p-button-success"
                  icon="pi pi-file-excel"
                  style="margin-right: 0.5rem"
                  @click="exportToExcel"
                />
                <Button
                  label="Print to PDF"
                  class="p-button-danger"
                  icon="pi pi-file-pdf"
                  @click="printToPDF"
                />
              </div>
            </div>
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading>Mengambil data barang. Mohon tunggu</template>
          <Column
            header="Kode Barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.cat_code }}
              </div>
            </template>
          </Column>

          <Column
            header="Nama Barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.cat_name }}
              </div>
            </template>
          </Column>

          <Column
            header="Jumlah Masuk"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.qty_in }}
              </div>
            </template>
          </Column>

          <Column
            header="Terjual"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.qty_sell }}
              </div>
            </template>
          </Column>

          <Column header="Retur" headerStyle="text-align: center; width: 10rem">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.qty_retur }}
              </div>
            </template>
          </Column>

          <Column
            header="Transfer"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.qty_transfer }}
              </div>
            </template>
          </Column>

          <Column
            header="Sisa (Qty)"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.stock_difference }}
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
import { mapState } from 'vuex'
import * as XLSX from 'xlsx'

export default {
  name: 'ItemsPerMonth',
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      moment: moment,
      loading: true,
      items: [],
      today: new Date().toISOString().split('T')[0],
      start_date: null,
      end_date: null,
      limit: 30,
      total_records: 0
    }
  },
  watch: {
    user(newValue) {
      console.log('User data changed:', newValue)
    }
  },
  mounted() {
    this.getAuthUser()
    this.getReportInbound()
  },
  methods: {
    getAuthUser() {
      console.info(this.user)
      if (this.user != undefined) {
        console.info('User data:', JSON.stringify(this.user))
      } else {
        console.error('User data is undefined')
      }
      this.start_date = new Date().toISOString().split('T')[0]
      this.end_date = new Date().toISOString().split('T')[0]
    },

    async getReportInbound(event) {
      let page = 0
      if (event) {
        page = event.page + 1
      }
      this.loading = true
      let start_date = this.start_date
        ? moment(this.start_date).format('YYYY-MM-DD')
        : this.today
      let end_date = this.end_date
        ? moment(this.end_date).format('YYYY-MM-DD')
        : this.today

      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/report-category-inbound?start_date=${start_date}&end_date=${end_date}&page=${page}&limit=${this.limit}`
        )

        if (response.status === 200) {
          this.items = response.data.data.category_inbound
          this.total_records = response.data.data.total
        } else {
          this.showToast('error', 'Error', 'Gagal mengambil data')
        }
      } catch (error) {
        this.showToast(
          'error',
          'Error',
          'Terjadi kesalahan saat mengambil data'
        )
      } finally {
        this.loading = false
      }
    },
    getReportInboundFilter() {
      this.loading = true
      if (this.end_date < this.start_date) {
        this.showToast('error', 'Error', 'Gagal mengambil data')
        this.loading = false
        this.start_date = this.today
        this.end_date = this.today
      } else {
        this.getReportInbound()
      }
    },

    // onPage(event) {
    //   this.first = event.first
    //   this.page = event.page + 1
    //   this.getReportInbound(this.page)
    // },

    closeDialog() {
      this.confirmDialog = false
    },

    getRowNumber(index) {
      return index + 1 + this.first
    },

    exportToExcel() {
      const worksheet = XLSX.utils.json_to_sheet(this.items)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Report')
      XLSX.writeFile(
        workbook,
        'Laporan Barang Masuk perbulan per kelompok barang.xlsx'
      )
    },

    async printToPDF() {
      if (!this.start_date || !this.end_date) {
        this.showToast('error', 'Error', 'Tanggal mulai dan akhir harus diisi')
        return
      }

      this.$root.openLinkNewTab('print-report-group-items-per-month', {
        start_date: moment(this.start_date).format('YYYY-MM-DD'),
        end_date: moment(this.end_date).format('YYYY-MM-DD')
      })
    }
  }
}
</script>

<style scoped lang="scss">
.outgoing-detail {
  font-family: monospace;
  width: 100%;
  margin: -50px auto;
  box-sizing: border-box;
  overflow: hidden;
}

.loading-message {
  color: black;
  text-align: center;
  margin: 20px 0;
}

.border-header {
  border-top: 2px solid black;
  width: 95%;
  margin: -4vh auto 0;
  justify-content: center;
}

.image {
  margin-top: -7px;
  width: 63px;
}

.title {
  text-align: center;
}

.detail-bon {
  margin-left: auto;
  margin-right: auto;
}

th,
td {
  padding: 5px;
}

::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
